import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';

const DemoRequestSuccess = () => {
  useEffect(() => {
    // Simple approach to scroll to top - most compatible across browsers
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-page bg-background min-h-screen">
      <Navigation />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <div className="inline-flex items-center justify-center h-20 w-20 rounded-full bg-gradient-to-r from-green-300 to-green-500 mb-6">
            <svg className="h-10 w-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-[#FF56A5] via-[#E852FF] to-[#9F44F2] bg-clip-text text-transparent">
              Thank You!
            </span>
          </h1>
          
          <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-1 mb-8">
            <div className="bg-gradient-to-br from-[#FF56A5]/20 via-[#E852FF]/20 to-[#9F44F2]/20 rounded-2xl p-8">
              <h2 className="text-2xl font-bold text-white mb-4">Your Demo Request Has Been Received</h2>
              
              <div className="mb-6 bg-white/10 rounded-xl p-6 backdrop-blur-md">
                <p className="text-lg text-white mb-4">
                  Please check your email and click the verification link to confirm your request.
                </p>
                <p className="text-md text-gray-300">
                  Once verified, our AI agent will immediately call you to better understand your goals. This brief discovery call helps us tailor the perfect demo for your use case.
                </p>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
                <div className="bg-white/5 rounded-xl p-4">
                  <div className="flex items-center mb-3">
                    <div className="w-8 h-8 mr-3 rounded-full bg-[#FF56A5]/20 flex items-center justify-center">
                      <svg className="w-4 h-4 text-[#FF56A5]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <h3 className="text-white font-semibold">Step 1</h3>
                  </div>
                  <p className="text-gray-400 text-sm">Check your inbox and verify your email address</p>
                </div>
                
                <div className="bg-white/5 rounded-xl p-4">
                  <div className="flex items-center mb-3">
                    <div className="w-8 h-8 mr-3 rounded-full bg-[#E852FF]/20 flex items-center justify-center">
                      <svg className="w-4 h-4 text-[#E852FF]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <h3 className="text-white font-semibold">Step 2</h3>
                  </div>
                  <p className="text-gray-400 text-sm">Be ready to speak with our AI agent – they’ll call seconds after you verify</p>
                </div>
                
                <div className="bg-white/5 rounded-xl p-4">
                  <div className="flex items-center mb-3">
                    <div className="w-8 h-8 mr-3 rounded-full bg-[#9F44F2]/20 flex items-center justify-center">
                      <svg className="w-4 h-4 text-[#9F44F2]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                      </svg>
                    </div>
                    <h3 className="text-white font-semibold">Step 3</h3>
                  </div>
                  <p className="text-gray-400 text-sm">Share your goals so our team can tailor a demo just for you</p>
                </div>
              </div>
            </div>
          </div>
          
          <p className="text-gray-400 mb-8">
            Didn’t get the email? Check your spam folder or <a href="mailto:info@lifelikeagents.com" className="text-[#E852FF] hover:text-[#FF56A5]">contact our team</a>. We're here to help.
          </p>
          
          <Link to="/" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gradient-to-r from-[#FF56A5] via-[#E852FF] to-[#9F44F2] hover:from-[#FF56A5]/90 hover:via-[#E852FF]/90 hover:to-[#9F44F2]/90">
            Return to Home
          </Link>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default DemoRequestSuccess; 